import { isDesktopRuntime } from '@/desktop/desktopDetection';
import { DESKTOP_LAYOUT_MEDIA_QUERY, useMediaQuery } from '@/hooks/useMediaQuery';
import { shellDescriptor, shellDrawsNavigation } from './shellDetection';

/**
 * F-0413 (AC-18): is the navigation laid out for a phone?
 *
 * ⛔ **The one place the question is answered.** In an app shell that draws its own bar it is the
 * shell's idiom: the iPhone is a phone in landscape too, and an iPad build older than F-0519 stays a
 * tablet at any window width. In a browser, and in the iPad app since F-0519 (`webNavigation`: the
 * web draws the navigation), it is the width below the desktop layout — 768 px, the same breakpoint
 * the bottom bar uses — so a Slide Over or a narrow Split View gets the phone layout by width, never
 * by device type. The desktop app keeps its sidebar at every width.
 */
export function usePhoneNavigation(): boolean {
  const wide = useMediaQuery(DESKTOP_LAYOUT_MEDIA_QUERY);
  return isPhoneNavigation(wide);
}

/** The rule itself, for a caller that already knows the width. */
export function isPhoneNavigation(wide: boolean): boolean {
  if (shellDrawsNavigation()) return shellDescriptor()?.idiom === 'phone';
  if (isDesktopRuntime()) return false;
  return !wide;
}
